export const deviderStyles = {
  lineHeight: '20px',
};
